import app from '../../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { Spinner } from './Spinner';

app.component('spinner', react2angular(Spinner, ['color'], []));
